// naive-ui input status for a required field: 'error' only after a submit
// was attempted with the field blank (`missing`), clearing itself as soon as
// the field has content — so the error outlives the validation toast without
// nagging while the user is still typing.
export function inputStatus(missing: boolean, value: string): 'error' | undefined {
  return missing && !value.trim() ? 'error' : undefined
}
